import { computed } from 'vue';

/**
 * Returns instance of URLSearchParams WebApi (https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
 * @param {String} str - search params, most likely will be window.location.search
 * @returns
 */
const getURLQueryParams = (str) => new URLSearchParams(str);

/**
 * Returns query param value
 * @param {String} key
 * @param {String} search - search params, most likely will be window.location.search
 * @returns
 */
export const getURLParam = (key, search) => {
  const searchParams = getURLQueryParams(search);
  return searchParams.get(key);
};

/**
 *
 * @param {*} key - key value of query param
 * @param {Function} fn  - callback function to update query param, passes in existing param value
 * @param {String} search - search params, most likely will be window.location.search
 * @returns
 */
const updateURLParam = (key, fn, search) => {
  const searchParams = getURLQueryParams(search);
  const currentVal = searchParams.get(key);

  searchParams.set(key, fn(currentVal));
  return searchParams;
};

/**
 * Returns reactive value of query param
 * @param {String} key
 * @returns {import('vue').WritableComputedRef<String | null>}
 */
export default function useQueryParam(key) {
  const { location, history } = window;
  const value = computed({
    get() {
      return getURLParam(key, location.search);
    },
    set(val) {
      const params = updateURLParam(key, () => val, location.search).toString();
      history.replaceState({}, '', `${location.pathname}?${decodeURIComponent(params)}`);
    },
  });

  return value;
}
